import './TypeaheadInput.scss';

import { Typeahead } from 'react-bootstrap-typeahead';
import classNames from 'classnames';

import Icon from 'atoms/icon';

export default function TypeaheadInput({
  className,
  onChange,
  items = [],
  item,
  id,
  labelKey,
  placeholder,
  shape = 'square',
  variant = 'white',
  displaySearchIcon,
}) {
  return (
    <div className="pos-relative typeahead-container">
      <Typeahead
        className={classNames(
          className,
          `typeahead typeahead--${shape} typeahead--${variant}`
        )}
        shape={shape}
        variant={variant}
        id={id}
        options={items}
        labelKey={labelKey}
        placeholder={placeholder}
        onChange={onChange}
        selected={item}
      />
      {displaySearchIcon && (
        <Icon
          name="search"
          className="pos-absolute"
          style={{ width: 11, fill: '#a1a1b8' }}
        />
      )}
    </div>
  );
}
